'use client'

import Noise from '@component/noise'
import BackReload from '@component/pages/backReload'
import ErrorLog from '@component/pages/errorLog'
import IconServerError from '@icon/server-error.svg'
import getRouter, { URLS } from '@router'
import DisablePrefetchLink from '@component/disablePrefetchLink'

export default function ErrorPage({
  error
}) {

  return (
    <Noise>
      <div className='py-80 text-center w-500 max-w-full mx-auto'>
        <IconServerError className='w-80 h-80 md:w-100 md:h-100'></IconServerError>
        <h1 className='text-lg md:text-2xl mb-20'>Oops! Something Went Wrong</h1>
        <div className='text-sm md:text-lg'>We're sorry, but the page couldn't load properly at this time. Please try again later or return to the <DisablePrefetchLink href={getRouter(URLS.homepage)} className='text-primary underline'>homepage</DisablePrefetchLink>.</div>
      </div>
      <BackReload></BackReload>
      <ErrorLog error={error}></ErrorLog>
    </Noise>
  )
}